import { AppButton, AppRadioBox, AppTextField, AppTextArea, AppSelectBox } from 'components';
import AppImagePicker from 'components/ImagePicker';
import { Link } from 'react-router-dom';
import { Fragment, useEffect, useState } from 'react';
import Joi from 'joi';
import { checkForErrors } from 'utilities/fns';
import ESTDropDown from 'components/molecules/ESTDropDown';
import UserRoleDropDown from 'components/molecules/UserRoleDropDown';
import ESClassDropDown from 'components/molecules/ESClassDropDown';
import ESDropDown from 'components/molecules/ESDropDown';
import UsersDropDown from 'components/molecules/UserDropDown';
import ClassSubjectsDropDown from 'components/molecules/ClassSubjectsDropDown';
import InstituteDropDown from 'components/molecules/InstituteDropDown';
import UserDropDownMultiple from 'components/molecules/UserDropDownMultiple';

function NotificationHandleSection({ handleNotification, preloadedData = {} }) {
  const [title, handleTitle] = useState('');
  const [shortTitle, handleShortTitle] = useState('');
  const [description, handleDescription] = useState('');
  const [EST, handleEST] = useState('');
  const [ES, handleES] = useState('');
  const [ESClass, handleESClass] = useState('');
  const [institute, handleInstitute] = useState('');
  const [subject, handleSubject] = useState('');
  const [role, handleRole] = useState('');
  const [recipients, handleRecipients] = useState([]);
  const [imageData, handleImageData] = useState(null);
  const [toBeSendOn, handleToBeSendOn] = useState('');
  const [disableSubmit, handleDisabling] = useState(false);

  const [event, handleEvent] = useState('');
  const [eventKey, handleEventKey] = useState('');

  const [displayType, setDisplayType] = useState('');
  const [formErrors, setFormErrors] = useState([]);

  function handleFormSubmission() {
    setFormErrors([]);
    const data = {
      role: role,
      est: EST,
      es: ES,
      institute: institute,
      class: ESClass,
      subject: subject,
      recipients: recipients,
      title: title,
      shortTitle: shortTitle,
      description: description,
      imageUrl: '',
      image: null,
      imageFullUrl: '',
      imageCaption: '',
      toBeSendOn: toBeSendOn,
      event: event,
      eventKey: eventKey,
      notificationType: displayType,
    };
    if (imageData && imageData.imageUrl) {
      data.imageUrl = imageData.imageUrl;
    }
    const validation = manageNotificationSchema.validate(data, {
      abortEarly: false,
      allowUnknown: true,
    });

    if (validation?.error) {
      setFormErrors(validation.error?.details ?? []);
      return;
    }

    handleNotification(data);
  }

  const errors = checkForErrors(formErrors);
  const handleDisplayType = (e) => {
    setDisplayType(e);
  };
  return (
    <Fragment>
      <div className="row">
        <div className="col-6">
          <h2 className="prime-head p-0">Manage Notification</h2>
          {/* <span>Class Details</span> */}
        </div>
        <div className="col-6 prime-head text-right">
          <Link to="/manage/notifications">
            <AppButton variantClass="btn-plane p--tint mx-2">&#8701; Back</AppButton>
          </Link>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 col-sm-12">
          <AppRadioBox
            inputProps={{
              name: 'displayType',
              onChange: () => handleDisplayType('general'),
            }}
            labelProps={{ label: 'General' }}
          />
          <AppRadioBox
            inputProps={{
              name: 'displayType',
              onChange: () => handleDisplayType('specific'),
            }}
            labelProps={{ label: 'Specific' }}
          />
        </div>
      </div>
      {displayType === 'specific' && (
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12">
            <UserRoleDropDown
              enableAPI
              value={role}
              handleChange={(event) => handleRole(event.target.value)}
              fieldErrors={errors['role']}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <ESTDropDown
              enableAPI
              value={EST}
              handleChange={(event) => handleEST(event.target.value)}
              fieldErrors={errors['EST']}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <ESDropDown
              enableAPI={!!EST}
              dependencies={{
                query: `estId=${EST}`,
              }}
              value={ES}
              handleChange={(event) => handleES(event.target.value)}
              fieldErrors={errors['ES']}
              defaultLook={false}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <ESClassDropDown
              enableAPI={!!ES}
              dependencies={{
                query: `esId=${ES}`,
              }}
              value={ESClass}
              fieldErrors={errors['ESClass']}
              handleChange={(event) => handleESClass(event.target.value)}
              defaultLook={false}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <InstituteDropDown
              enableAPI={!!ES}
              dependencies={{
                query: `esId=${ES}`,
              }}
              value={institute}
              fieldErrors={errors['institute']}
              handleChange={(event) => handleInstitute(event.target.value)}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <ClassSubjectsDropDown
              enableAPI={!!ESClass}
              dependencies={{
                query: `classId=${ESClass}`,
              }}
              value={subject}
              handleChange={(event) => handleSubject(event.target.value)}
              fieldErrors={errors['subject']}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <UserDropDownMultiple
              enableAPI={!!role}
              dependencies={{
                query: `role=${role}`,
              }}
              value={recipients}
              fieldErrors={errors['recipients']}
              handleChange={(event) => handleRecipients(event)}
            />
            {/* <UsersDropDown
              enableAPI={!!role}
              dependencies={{
                query: `role=${role}`,
              }}
              value={recipients}
              fieldErrors={errors['recipients']}
              handleChange={(event) => handleRecipients(event.target.value)}
            /> */}
          </div>
        </div>
      )}
      {(displayType === 'general' || displayType === 'specific') && (
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12">
            <AppTextField
              inputProps={{
                value: title,
                onChange: (event) => handleTitle(event.target.value),
              }}
              labelProps={{ label: 'Title' }}
              fieldErrors={errors['title']}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <AppTextField
              inputProps={{
                value: shortTitle,
                onChange: (event) => handleShortTitle(event.target.value),
              }}
              labelProps={{ label: 'Short Title' }}
              fieldErrors={errors['shortTitle']}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <AppTextArea
              inputProps={{
                value: description,
                onChange: (event) => handleDescription(event.target.value),
              }}
              label="Description"
              fieldErrors={errors['description']}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <AppImagePicker
              image={imageData?.imageUrl}
              handleChange={(imageData) => handleImageData(imageData)}
              handleDisabling={(doDisable) => handleDisabling(doDisable)}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <AppTextField
              inputProps={{
                value: toBeSendOn,
                type: 'datetime-local',
                onChange: (event) => handleToBeSendOn(event.target.value),
              }}
              labelProps={{ label: 'Send Date' }}
              fieldErrors={errors['toBeSendOn']}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <AppSelectBox
              labelProps={{ label: 'Event' }}
              selectProps={{
                event,
                onChange: (event) => handleEvent(event.target.value),
              }}
            >
              <option disabled value="">
                Choose
              </option>
              <option value="general">General</option>
              <option value="navigate">Navigate</option>
              <option value="upgrade">Upgrade</option>
            </AppSelectBox>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <AppTextField
              inputProps={{
                value: eventKey,
                onChange: (event) => handleEventKey(event.target.value),
              }}
              labelProps={{ label: 'Event Key' }}
              fieldErrors={errors['eventKey']}
            />
          </div>
        </div>
      )}

      <div className="row mt-5">
        <div className="col-12 btnTab-foot">
          <AppButton variantClass="btn-right-content save" onClick={handleFormSubmission}>
            Save Changes
          </AppButton>
        </div>
      </div>
    </Fragment>
  );
}

NotificationHandleSection.defaultProps = {
  handleNotification: () => {},
};

const manageNotificationSchema = Joi.object({
  title: Joi.string().required().min(5),
  event: Joi.string().required(),
});

export default NotificationHandleSection;
